import { TeamTemplateType } from "@teaming/common-enums";

const {
	REGULARLY_SCHEDULED_TEAM_MEETING,
	DAILY_STANDUP,
	SET_TEAM_GOALS,
	TEAM_RETROSPECTIVE,
	ALLSTATE_WEEKLY_TEAM_MEETING,
} = TeamTemplateType;

export default {
	// 01-regularly-scheduled-team-meeting.json
	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_title` ]: "Regularly Scheduled Team Meeting",
	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_description` ]: "Check-in on the most important work priorities each week.",
	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_topic1` ]: "Team Ice Breaker",
	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_topic1paragraph1` ]: "[Grab an icebreaker from the Topics -->]",

	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_topic2` ]: "Review Goals/OKRs",
	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_topic2bullet1` ]: "What went well last week?",
	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_topic2bullet2` ]: "What could have gone better?",
	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_topic2bullet3` ]: "What do you want to accomplish this week?",

	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_topic3` ]: "Blockers",
	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_topic3bullet1` ]: "Anything blocking us this week?",
	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_topic3bullet2` ]: "How can I help?",

	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_topic4` ]: "Questions",
	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_topic4paragraph1` ]: "Anything else we should discuss today?",

	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_topic5` ]: "Shoutouts",
	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_topic5bullet1` ]: "Who deserves a shoutout?",
	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_topic5bullet2` ]: "Anyone receive feedback from our team's stakeholders",

	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_topic6` ]: "Action items",
	[ `TEAM_${ REGULARLY_SCHEDULED_TEAM_MEETING }_topic6actionItem1` ]: "What action items do we have from this meeting?",

	// 02-daily-standup.json
	[ `TEAM_${ DAILY_STANDUP }_title` ]: "Daily Standup",
	[ `TEAM_${ DAILY_STANDUP }_description` ]: "Short, daily, standing meeting to focus on getting into a flow of work together as a team.",

	[ `TEAM_${ DAILY_STANDUP }_topic1` ]: "Questions for each team member",
	[ `TEAM_${ DAILY_STANDUP }_topic1bullet1` ]: "What did you accomplish yesterday?",
	[ `TEAM_${ DAILY_STANDUP }_topic1bullet2` ]: "What are your goals for today?",
	[ `TEAM_${ DAILY_STANDUP }_topic1bullet3` ]: "Do you have any blockers?",

	[ `TEAM_${ DAILY_STANDUP }_topic2` ]: "Questions from the manager/lead",
	[ `TEAM_${ DAILY_STANDUP }_topic2bullet1` ]: "What do we need to do to advance or complete this piece of work?",
	[ `TEAM_${ DAILY_STANDUP }_topic2bullet2` ]: "Does anyone have work that's not been represented?",
	[ `TEAM_${ DAILY_STANDUP }_topic2bullet3` ]: "What can we finish as a team today?",

	// 03-set-team-goals.json
	[ `TEAM_${ SET_TEAM_GOALS }_title` ]: "Set Team Goals",
	[ `TEAM_${ SET_TEAM_GOALS }_description` ]: "Set clear, measurable goals with the team.",

	[ `TEAM_${ SET_TEAM_GOALS }_topic1` ]: "What should our goals be for the next month/quarter/year?",
	[ `TEAM_${ SET_TEAM_GOALS }_topic2` ]: "How do these goals positively impact our company goals?",
	[ `TEAM_${ SET_TEAM_GOALS }_topic3` ]: "What should we start/stop/continue doing to reach these goals?",
	[ `TEAM_${ SET_TEAM_GOALS }_topic4` ]: "What kind of support/resources do we need to achieve our goals?",
	[ `TEAM_${ SET_TEAM_GOALS }_topic5` ]: "What are potential obstacles in the way of achieving these goals?",
	[ `TEAM_${ SET_TEAM_GOALS }_topic6` ]: "Are these goals challenging but attainable?",
	[ `TEAM_${ SET_TEAM_GOALS }_topic7` ]: "How will we measure and track your progress on these goals?",
	[ `TEAM_${ SET_TEAM_GOALS }_topic7actionItem1` ]: "Add Goals and Key Measures in the Goals tab",

	// 04-team-retrospective.json
	[ `TEAM_${ TEAM_RETROSPECTIVE }_title` ]: "Team Retrospective",
	[ `TEAM_${ TEAM_RETROSPECTIVE }_description` ]: "Improve teamwork by reflecting on what worked, what didn't, why, and what actions you'll take together in the future. You can run a Retrospective with your team every couple of weeks or when a milestone is reached.",

	[ `TEAM_${ TEAM_RETROSPECTIVE }_heading1` ]: "Set the tone",
	[ `TEAM_${ TEAM_RETROSPECTIVE }_heading1bullet1` ]: "Listen with an open mind",
	[ `TEAM_${ TEAM_RETROSPECTIVE }_heading1bullet2` ]: "Everyone's experience is valid",
	[ `TEAM_${ TEAM_RETROSPECTIVE }_heading1bullet3` ]: "Set the period you're discussing (last sprint, last quarter, entire project, etc.)",
	[ `TEAM_${ TEAM_RETROSPECTIVE }_heading1bullet4` ]: "Focus on improvement, rather than placing blame",
	[ `TEAM_${ TEAM_RETROSPECTIVE }_heading1bullet5` ]: "Don't make it personal / don't take it personally",

	[ `TEAM_${ TEAM_RETROSPECTIVE }_topic1` ]: "What we did well",
	[ `TEAM_${ TEAM_RETROSPECTIVE }_topic1paragraph1` ]: "Using either a digital whiteboard or a physical one, have each team member write down what the team did well, one idea per note. Post the notes, and group similar or duplicate ideas together. Discuss each one briefly as a team.",

	[ `TEAM_${ TEAM_RETROSPECTIVE }_topic2` ]: "What we can do better",
	[ `TEAM_${ TEAM_RETROSPECTIVE }_topic2paragraph1` ]: "Have everyone write down what they think can be improved, one idea per note. Post the notes, and group similar or duplicate ideas together. Discuss each theme as a team.",

	[ `TEAM_${ TEAM_RETROSPECTIVE }_topic3` ]: "Actions",
	[ `TEAM_${ TEAM_RETROSPECTIVE }_topic3paragraph1` ]: "Have everyone brainstorm actions that can be taken to improve problem areas, one idea per note. Post the notes and group similar or duplicate ideas.",
	[ `TEAM_${ TEAM_RETROSPECTIVE }_topic3actionItem1` ]: "Discuss each idea as a team, and assign owners to these actions and due dates where applicable.",

	// allstate/01-allstate-daily-review
	[ `TEAM_${ ALLSTATE_WEEKLY_TEAM_MEETING }_title` ]: "Weekly Team Meeting",
	[ `TEAM_${ ALLSTATE_WEEKLY_TEAM_MEETING }_description` ]: "Check-in with the team, discuss important topics, and maintain focus on team goals.",
	[ `TEAM_${ ALLSTATE_WEEKLY_TEAM_MEETING }_topic1` ]: "Check-in",
	[ `TEAM_${ ALLSTATE_WEEKLY_TEAM_MEETING }_topic1paragraph1` ]: "On a scale of 0 – 5, (with five being the best), rate how you are feeling today.",
	[ `TEAM_${ ALLSTATE_WEEKLY_TEAM_MEETING }_topic1paragraph2` ]: "Unpack a little if you’re willing to. Whether you’re on a high or low, remember that candor and vulnerability foster empathy and trust.",
	[ `TEAM_${ ALLSTATE_WEEKLY_TEAM_MEETING }_topic2` ]: "Scoreboard Review",
	[ `TEAM_${ ALLSTATE_WEEKLY_TEAM_MEETING }_topic2paragraph1` ]: "Review each set of goals and KRs. Update any necessary metrics, and review/discuss your shared level of confidence for each.",
	[ `TEAM_${ ALLSTATE_WEEKLY_TEAM_MEETING }_topic3` ]: "Quick Updates",
	[ `TEAM_${ ALLSTATE_WEEKLY_TEAM_MEETING }_topic3paragraph1` ]: "Each team member should list highlights or changes important for the team to know. What happened since the last meeting? What milestones have been completed? Keep updates brief and concise.",
	[ `TEAM_${ ALLSTATE_WEEKLY_TEAM_MEETING }_topic4` ]: "Real Time Agenda Items",
	[ `TEAM_${ ALLSTATE_WEEKLY_TEAM_MEETING }_topic4paragraph1` ]: "The bulk of your meeting time. As you complete the Scoreboard Review and Quick Updates, you should add items to discuss here. Once complete, then prioritize the topics in order of importance/urgency. If you think the topic will take more than 10-15 min., then you should move it to the Parking Lot and setup time to address it separately.",
	[ `TEAM_${ ALLSTATE_WEEKLY_TEAM_MEETING }_topic5` ]: "Parking Lot for Topics",
	[ `TEAM_${ ALLSTATE_WEEKLY_TEAM_MEETING }_topic5paragraph1` ]: "Items deferred from prior meetings or parked for future discussion. Teammates should also feel free to suggest additional topics here.",
	[ `TEAM_${ ALLSTATE_WEEKLY_TEAM_MEETING }_topic6` ]: "Review and Confirm Action Items and Decisions",
	[ `TEAM_${ ALLSTATE_WEEKLY_TEAM_MEETING }_topic6paragraph1` ]: "Take a moment to review the action items and decisions you’ve collected through the meeting, so everyone’s on the same page about next steps.",
};
